import { render, staticRenderFns } from "./hc-loading.vue?vue&type=template&id=0ed8f994&scoped=true&"
import script from "./hc-loading.vue?vue&type=script&lang=js&"
export * from "./hc-loading.vue?vue&type=script&lang=js&"
import style0 from "./hc-loading.vue?vue&type=style&index=0&id=0ed8f994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8f994",
  null
  
)

export default component.exports